import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { ActionButtonLink } from 'App/components/styles/ActionCell';
import PatientNotesModal from './components/PatientNotesModal';
import useFetchPatientProfileNotesQuery from 'App/hooks/useFetchPatientProfileNotesQuery';
import PatientImportantNotesIndicator from '../PatientImportantNotesIndicator';

const propTypes = {
    patientId: PropTypes.string,
};

const defaultProps = {
    patientId: undefined,
};

const PatientProfileNotes = ({ patientId }) => {
    const { data } = useFetchPatientProfileNotesQuery(patientId);
    const [showModal, setShowModal] = useState(false);
    const hasPatientId = !!patientId;

    return (
        <>
            <ActionButtonLink onClick={() => hasPatientId && setShowModal(true)} disabled={!hasPatientId}>
                View Notes ({data?.length || 0})
                {hasPatientId && <PatientImportantNotesIndicator patientId={patientId} />}
            </ActionButtonLink>
            {hasPatientId && (
                <PatientNotesModal showModal={showModal} patientId={patientId} onHide={() => setShowModal(false)} />
            )}
        </>
    );
};

PatientProfileNotes.propTypes = propTypes;
PatientProfileNotes.defaultProps = defaultProps;

export default PatientProfileNotes;
